"use client";
import Cookie from "js-cookie";
import { AUTH_TOKEN_KEY, GET_TOKEN_FAILURE_COUNT_KEY } from "./wcsToken/constants.js";
const wcsUtils = {
  filterItems: function(logOffUrls, currentDomain) {
    return logOffUrls.filter(function(url) {
      return url.toLowerCase() !== currentDomain.toLowerCase();
    });
  },
  logoutSso: function(logOffUrls) {
    try {
      sessionStorage.removeItem("SelectedPatientIndex");
      this.removeCookie("PrescriptionCount");
      sessionStorage.removeItem(
        `${AUTH_TOKEN_KEY}_${Cookie.get("hashedUserId")}`
      );
      sessionStorage.removeItem(GET_TOKEN_FAILURE_COUNT_KEY);
      localStorage == null ? void 0 : localStorage.removeItem("azure_token");
      localStorage == null ? void 0 : localStorage.removeItem("idToken");
      const isMobileApp = (
        // @ts-expect-error - Android and webkit are global variables set by WCS
        typeof Android !== "undefined" || typeof webkit !== "undefined"
      );
      if (isMobileApp) {
        this.performMobileLogout();
        return;
      }
      this.performSsoLogout(logOffUrls);
    } catch (error) {
      console.error("Error during logout:", error);
    }
  },
  performMobileLogout: function() {
    try {
      console.log("Performing mobile app logout");
      if (typeof Android !== "undefined") {
        Android.onSignOut();
      } else if (typeof webkit !== "undefined") {
        webkit.messageHandlers.onSignOut.postMessage("");
      }
      console.log("Mobile app logout completed");
    } catch (error) {
      console.error("Error during mobile app logout:", error);
    }
  },
  performSsoLogout: function(logOffUrls) {
    try {
      if (!logOffUrls || !logOffUrls.length) {
        console.log(
          "No logout URLs provided. Performing default logout."
        );
        return;
      }
      const filteredUrls = this.filterItems(
        logOffUrls,
        window.location.origin
      );
      if (!filteredUrls.length) {
        console.log(
          "No valid logout URLs found. Performing default logout."
        );
        return;
      }
      const logOffAction = "/security/v1/users/session/ssologoff";
      const targetUri = filteredUrls[0] + logOffAction + "?a=" + filteredUrls[1] + logOffAction + "&b=" + filteredUrls[2] + logOffAction + "&c=" + filteredUrls[3] + "/Account/Logout";
      const logoffWindow = window.open(targetUri, "_blank");
      setTimeout(function() {
        const wcsLogoutUrl = window.location.origin + "/Logoff?usrClk=true";
        logoffWindow == null ? void 0 : logoffWindow.close();
        window.location.href = wcsLogoutUrl;
      }, 3800);
    } catch (error) {
      console.error("Error during server logout:", error);
    }
  },
  removeCookie: function(name) {
    document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }
};
async function signOut() {
  var _a;
  const logoutUrls = ((_a = process.env.NEXT_PUBLIC_LOGOUT_URLS) == null ? void 0 : _a.split(",")) || [];
  wcsUtils.logoutSso(logoutUrls);
}
export {
  signOut
};
